<!-- Текущий кабинет ЭДО из готового backend-представления integration_card. -->
<template>
  <BaseRelatedRecordCard
    :title="title"
    :subtitle="subtitle"
    icon="saby"
    :to="documentsRoute"
    view-title="Открыть документы этой интеграции в новой вкладке"
  />
</template>

<script>
export default {
  name: "EdoDocumentIntegrationCard",

  props: {
    integrationCard: {
      type: Object,
      default: null,
    },
    integrationLabel: {
      type: String,
      default: "",
    },
  },

  computed: {
    documentsRoute() {
      if (!this.integrationCard?.id) return null;

      return {
        name: "EdoDocuments",
        query: { "q[integration_id]": this.integrationCard.id },
      };
    },

    title() {
      return this.integrationCard?.title ||
        this.integrationCard?.provider_name ||
        this.integrationLabel ||
        "Интеграция не указана";
    },

    subtitle() {
      const details = [
        this.integrationCard?.subtitle,
        this.integrationCard?.login,
      ].filter(Boolean);

      return [...new Set(details)].join(" · ");
    },
  },
};
</script>
